import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import { Card } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function DetailBrand({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const brand = useSelector((state) => state.brand);

  useEffect(() => {
    dispatch(actions.brandGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (brand.isLoading || brand.rows) {
    return <Loading />;
  }
  if (!brand.isLoading && brand.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">ข้อมูลแบรนด์</div>
        </div>
        <div>
          <Card className="p-4 ">
            <div className="flex flex-wrap divide-y">
              <div className="w-full py-4 text-lg font-semibold ">
                {'รายละเอียด'}
              </div>
              <div className="w-1/2 py-4 px-2 font-semibold ">{'ชื่อ'}</div>
              <div className="w-1/2 py-4 ">{`${brand.name}`}</div>
              <div className="w-1/2 py-4 px-2 font-semibold ">
                {'รายละเอียด'}
              </div>
              <div className="w-1/2 py-4 ">{`${brand.description || '-'}`}</div>
              {brand?.image ? (
                <>
                  <div className="w-full py-4 px-2 font-semibold ">รูปภาพ</div>
                  <div className="w-full flex">
                    <img src={brand?.image?.url} className="w-64 my-auto " />
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

DetailBrand.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DetailBrand.defaultProps = {
  title: '',
  subtitle: '',
};
